module.exports = __webpack_public_path__ + "static/img/manhole.a151c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/manhole.png
// module id = UeU6
// module chunks = 0